import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SaleDteRealtimeMessage } from '../../../types/websocket/SaleDteRealtimeMessage'


interface SaleDteRealtimeState {
  visible: boolean

  current: SaleDteRealtimeMessage | null
}

const initialState: SaleDteRealtimeState = {
  visible: false,
  current: null,
}

export const saleDteRealtimeSlice = createSlice({
  name: 'saleDteRealtime',

  initialState,

  reducers: {
    setRealtimeState: (
      state,
      action: PayloadAction<SaleDteRealtimeMessage>
    ) => {
      state.visible = true
      state.current = action.payload
    },

    clearRealtimeState: (state) => {
      state.visible = false
      state.current = null
    },
  },
})

export const {
  setRealtimeState,
  clearRealtimeState,
} = saleDteRealtimeSlice.actions

export default saleDteRealtimeSlice.reducer